import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import finLogo from '../Img/fin-evovle-logo.png'

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <header className="header-smco">
      {/* Top Bar */}
      {/* 
      <div className="header-top-bar-smco">
        <a href="tel:+919730787814" className="header-bold-smco">
          <i className="fa-solid fa-mobile-button"></i> +918369698298        </a>
        &nbsp; | &nbsp;
        <a href="mailto:contact@krsfinsolutions.com" className="header-email-smco">
          <i className="fa-solid fa-envelope"></i> contact@krsfinsolutions.com
        </a>
      </div>
      */}

      {/* Navigation */}
      <nav className="header-nav-smco">
       <img src={finLogo} alt="KRS FinSolutions" onClick={() => navigate("/")}/>

        {/* Desktop Navigation */}
        <ul className="header-nav-links-smco">
          {location.pathname !== "/" && (
            <li onClick={() => navigate("/")}>Home</li>
          )}
          <li onClick={() => navigate("/about-KRS-FinSolutions")}>About us</li>
          <li onClick={() => navigate("/Our-services")}>Services</li>
          <li onClick={() => navigate("/contact-loan-experts")}>Contact us</li>
        </ul>

        {/* Apply Now Button (Desktop) */}
        <button className="header-apply-btn-smco" onClick={() => navigate("/contact-loan-experts")}>
          Get in touch
        </button>

        {/* Custom Hamburger (For Mobile) */}
        <div className="header-hamburger-smco" onClick={() => setDrawerOpen(true)}>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </nav>

      {/* Drawer (For Mobile) */}
      <div className={`header-drawer-smco ${drawerOpen ? "open" : ""}`}>
        <button className="header-drawer-close-smco" onClick={() => setDrawerOpen(false)}><i className="fa-solid fa-xmark"></i></button>
        <ul>
          {location.pathname !== "/" && (
            <li onClick={() => { navigate("/"); setDrawerOpen(false); }}>Home</li>
          )}
          <li onClick={() => { navigate("/about-KRS-FinSolutions"); setDrawerOpen(false); }}>About</li>
          <li onClick={() => { navigate("/Our-services"); setDrawerOpen(false); }}>Services</li>
          <li onClick={() => { navigate("/contact-loan-experts"); setDrawerOpen(false); }}>Contact</li>
          <button className="header-apply-btn-drawer-smco" onClick={() => { navigate("/contact-loan-experts"); setDrawerOpen(false); }}>
            Get in touch
          </button>
        </ul>
      </div>
    </header>
  );
};

export default Header;
